import gql from 'graphql-tag';

const BLOG_ENTRIES_QUERY = gql`
    query BlogEntries {
        blogEntries (sort: "date:asc") {
            id
            title
            summary
            blog_category {
                id
                title
            }
            published_at
            hero {
                url
            }
            blog_type
            slug
            event_date_start
            event_date_end
            event_url,
            tags {
                name
                id
            }
        }
    }
`;

export default BLOG_ENTRIES_QUERY;
